import { registerDictionary } from '@/commons/popupRegister/dictionaryRegister.js';
import { registerTreasury } from '@/commons/popupRegister/treasuryRegister.js';
import { registerInventory } from '@/commons/popupRegister/inventoryRegister.js';
import { registerParams } from '@/commons/popupRegister/reportParamRegister.js';
import { registerBA } from '@/commons/popupRegister/registerBA.js';
import { registerReport } from '@/commons/popupRegister/registerReport.js';
import { registerCommonPopup } from '@/commons/popupRegister/commonPopupRegister.js';
import { registerCash } from '@/commons/popupRegister/cashRegister.js';
import { registerSU } from '@/commons/popupRegister/sURegister.js';
import { registerPU } from '@/commons/popupRegister/pURegister.js';
import { registerPA } from '@/commons/popupRegister/pARegister.js';
import { registerSA } from '@/commons/popupRegister/sARegister.js';
import { registerAssetQLTS } from '@/commons/popupRegister/assetQLTSRegister.js';
import { registerGL } from '@/commons/popupRegister/gLRegister.js';
import { registerCRE } from '@/commons/popupRegister/cRERegister.js';
import { registerOpening } from '@/commons/popupRegister/openingRegister.js';
import { registerConnect } from '@/commons/popupRegister/connectRegister.js';
import { registerInitialBalance } from '@/commons/popupRegister/initialBalanceRegister.js';
import { registerFr } from '@/commons/popupRegister/fRRegister.js';
import { registerETreasury } from '@/commons/popupRegister/eTreasuryRegister.js';
import { registerConvert } from '@/commons/popupRegister/convertRegister.js';
import { registerAccessHistory } from '@/commons/popupRegister/accessHistoryRegister.js';
import { registerAsset } from '@/commons/popupRegister/assetRegister.js';
import { registerDashboard } from '@/commons/popupRegister/dashboardRegister.js';
import { registerNotification } from '@/commons/popupRegister/notificationRegister.js';
import { registerTA } from '@/commons/popupRegister/tARegister.js';
import { registerDatabase } from '@/commons/popupRegister/databaseRegister.js';
import { registerClientTool } from '@/commons/popupRegister/clientToolRegister.js';

export function register(app) {
  registerDictionary(app);
  registerTreasury(app);
  registerInventory(app);
  registerParams(app);
  registerBA(app);
  registerReport(app);
  registerCommonPopup(app);
  registerCash(app);
  registerSU(app);
  registerPU(app);
  registerPA(app);
  registerSA(app);
  registerAssetQLTS(app);
  registerGL(app);
  registerCRE(app);
  registerOpening(app);
  registerConnect(app);
  registerInitialBalance(app);
  registerFr(app);
  registerETreasury(app);
  registerConvert(app);
  registerAccessHistory(app);
  registerAsset(app);
  registerDashboard(app);
  registerNotification(app);
  registerTA(app);
  registerDatabase(app);
  registerClientTool(app);
}
